import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DocumentLibraryConstants } from '../document-library-constants';
import { TrainingPlanDto } from '../../shared/models/trainingPlan/trainingPlanDto';
import { DocumentService } from '../services/document.service';
import { MessageService } from 'primeng/api';
import { NameCode } from '../../shared/models/name-code';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-document-training',
  templateUrl: './document-training.component.html',
  styleUrls: ['./document-training.component.scss']
})
export class DocumentTrainingComponent implements OnInit {
  constructor(private documentService: DocumentService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef) {

  }
  confirmationMessage: string = DocumentLibraryConstants.DocumentTraining_ConfirmationMessage;
  buttonLabel: string = DocumentLibraryConstants.DocumentTraining_ButtonLabel;
  displayQuizCompletionBtn: string = DocumentLibraryConstants.DocumentTraining_ButtonLabel_WithQuiz;
  displayQuizCompletion: boolean = false;
  confirmationMessageForQuizTaking: string = DocumentLibraryConstants.DocumentQuizCompletion_ConfirmationMessage;
  trainingPlan!: any
  trainingPlanDetails : TrainingPlanDto = {} as TrainingPlanDto;

  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() trainingItemGroups: any[] = [];
  @Output() reloadDocumentDetails = new EventEmitter<Event>();
  quizDataForDocument: any;
  documentProficiencyQuizPersistedDetails: any;
  documentProficiencyQuiz: any = 0;//For document proficiency Quiz Type
  showQuiz: boolean = false;
  ifTakeQuiz: boolean = false;
  disabled: boolean = false;


  ngOnInit(): void {
    this.getTrainingItemGroups()

  }

  
  getTrainingItemGroups(){
    this.documentService.getTrainingItemGroupForDocument(this.documentNumber).subscribe((response)=>{
      this.trainingItemGroups = response;
      this.getTrainingData();
      this.cd.detectChanges();
    })
  }

  reloadDocumentTraining() {
    this.reloadDocumentDetails.emit();
    this.getTrainingData();
  }
  openQuiz = () => {
    this.showQuiz = true;
  }

  getTrainingData() {
    this.documentService.getTrainingDataForDocumentVersion(this.documentNumber,this.documentVersion).subscribe((trainingPlan)=>{
      this.trainingPlan = trainingPlan;
      this.trainingPlanDetails =this.setTrainingPlanDetails(this.trainingPlan, this.trainingItemGroups);
      if (this.trainingPlanDetails.isTrainingPlanCreated) {
        this.disabled=!this.trainingPlanDetails.isNoQuiz;
      } else {
        this.disabled = true;
      }
      
      if(!this.trainingPlanDetails.isNoQuiz)
      {
        this.getProficiencyQuizData();
      }
    })
  }

  getProficiencyQuizData() {
    this.documentService.getDocumentProficiencyQuizDetails(this.documentNumber,
      Number(this.documentVersion)).subscribe((response) => {
        this.documentProficiencyQuizPersistedDetails = response;
        this.ifTakeQuiz = this.documentProficiencyQuizPersistedDetails.requiresProficiencyQuiz;
        this.quizDataForDocument = this.documentProficiencyQuizPersistedDetails;
        var attempts = this.trainingPlanDetails.maximumAttempts != null ? this.trainingPlanDetails.maximumAttempts :
          DocumentLibraryConstants.DocumentTraining_QuizMaximumAttempts_Unlimited;
        this.confirmationMessage = this.confirmationMessageForQuizTaking.replace('{0}', `${attempts}`);
        if (this.ifTakeQuiz) {
          this.buttonLabel = this.displayQuizCompletionBtn;
        }
        if (this.trainingPlanDetails.isTrainingPlanCreated) {
          this.disabled = !this.trainingPlanDetails.isDocumentQuizBtnEnable;
          this.cd.detectChanges();
        } else {
          this.disabled = true;
        }
      });
  }

  updateTrainingPlan() {
    this.documentService.updateTrainingPlanForDocumentTrainingItem(this.documentNumber, this.documentVersion).subscribe({
      next: (serviceData) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Success,
          summary: DocumentLibraryConstants.DocumentTraining_UpdatedSuccessfully
        })
        this.trainingPlanDetails.isNoQuiz = false;
        this.getProficiencyQuizData();
        this.cd.detectChanges();
      },
      error: (error) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: DocumentLibraryConstants.DocumentQuiz_UpdateTrainingPlan_FailMessage,
          sticky: true
        });
        this.cd.detectChanges();
      }
    })
  }

  setTrainingPlanDetails = (trainingPlanDetails:any,
    trainingItemGroups : NameCode[]) : TrainingPlanDto => {
    this.trainingPlanDetails.coreCurriculums = trainingPlanDetails.coreCurriculums;
    this.trainingPlanDetails.electiveCurriculums = trainingPlanDetails.electiveCurriculums;
    this.trainingPlanDetails.isButtonEnabled = trainingPlanDetails.isButtonEnabled;
    this.trainingPlanDetails.isQuizCompletionButtonVisible = trainingPlanDetails.isQuizCompletionButtonVisible;
    this.trainingPlanDetails.isNoQuiz = trainingPlanDetails.isNoQuiz;
    this.trainingPlanDetails.isCourseSelfStudyWithQuiz = trainingPlanDetails.isCourseSelfStudyWithQuiz;
    this.trainingPlanDetails.isCourseInstructorLedWithQuiz = trainingPlanDetails.isCourseInstructorLedWithQuiz;
    this.trainingPlanDetails.maximumAttempts = trainingPlanDetails.maximumAttempts;
    this.trainingPlanDetails.courseFormat = trainingPlanDetails.courseFormat;
    this.trainingPlanDetails.quizType = trainingPlanDetails.quizType;
    this.trainingPlanDetails.isDocumentQuizBtnEnable = trainingPlanDetails.isDocumentQuizBtnEnable;
    this.trainingPlanDetails.isTrainingPlanCreated = trainingPlanDetails.isTrainingPlanCreated;
    this.trainingPlanDetails.trainingItemGroups = trainingItemGroups.map(i=>i.name);
    return this.trainingPlanDetails
  }
}
